import { SelectionChangedEvent } from "ag-grid-community";
import { RecalProposalSetEntity } from "domain/entity/RecalProposalSet/RecalProposalSetEntity";
import { MessageConstant } from "presentation/constant/MessageConstant";
import { INITIAL_RECAL_PROPOSAL_SET_COL_DEF, transferRowData } from "presentation/constant/RecalProposalSet/RecalProposalSetColumnDefinition";
import { RecalProposalSetConstant } from "presentation/constant/RecalProposalSet/RecalProposalSetConstant";
import { WorkspaceConstant } from "presentation/constant/WorkSpaceConstant";
import { useRecalProposalSetVM } from "presentation/hook/RecalProposalSet/useRecalProposalSetVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useRecalProposalSetTracked } from "presentation/store/RecalProposalSet/RecalProposalSetProvider";
import { ConfirmDeleteModal } from "presentation/view/components/ConfirmDeleteModal";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useMemo, useRef, useState } from "react";
import { Loader } from "veronica-ui-component/dist/component/core";
const RecalProposalSetTablePanel = () => {
    const gridRef: any = useRef(null);
    const [recalProposalSetState] = useRecalProposalSetTracked();
    const { selectedRows } = recalProposalSetState;
    const recalProposalSetVM = useRecalProposalSetVM();
    const messageBarVM = useMessageBarVM();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isShowDelete, setIsShowDelete] = useState<boolean>(false);

    // const [onTableSelectionClicked, setOnTableSelectionClicked] = useState<boolean>(false);
    const [anainfoState] = useANAInfoTracked();
    const { allowCreate, allowDelete } = anainfoState;

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        // setOnTableSelectionClicked(true);
        recalProposalSetVM.updateSelectedRows(selectedRows);
    }, [recalProposalSetVM])

    const handleRowDoubleClick = useCallback((entity: RecalProposalSetEntity) => {
        recalProposalSetVM.onRowDoubleClick(entity);
    }, [recalProposalSetVM])

    const handleAdd = useCallback(() => {
        recalProposalSetVM.onAddClick();
    }, [recalProposalSetVM]);

    const handleRowDeleteClick = useCallback(async () => {
        if (!selectedRows || selectedRows.length === 0) {
            messageBarVM.showError("Please select a record(s) to delete.");
            return;
        }
        setIsShowDelete(true);
    }, [selectedRows, messageBarVM]);

    const handleCancel = () => {
        setIsShowDelete(false);
    }

    const handleDelete = useCallback(() => {
        setIsLoading(true);
        setIsShowDelete(false);
        recalProposalSetVM.onDelete(selectedRows).then(async (res) => {
            if (res && res.success) {
                messageBarVM.showSuccess(MessageConstant.common.DELETED_DATA_SUCCESSFUL);
                await recalProposalSetVM.searchAllRecalProposalSetList();
            } else {
                messageBarVM.showError("Delete Failed.");
            }
            setIsLoading(false)
        });
    }, [recalProposalSetVM, messageBarVM, selectedRows]);

    const memoBtns = useMemo(() => {
        const hdrBtns = [];
        allowDelete && hdrBtns.push({
            id: 'onDeleteButton',
            icon: 'Icon-trash',
            title: 'Delete'
        })

        return hdrBtns
    }, [allowDelete])

    const memoRecalProposalSetTable = useMemo(() => {

        return (
            <>
                <div id="myDiv">
                    <NbisTable
                        id='recal-proposal-set-table'
                        headerLabel={RecalProposalSetConstant.Title.TITLE}
                        isNewColumnSetting={true}
                        columns={INITIAL_RECAL_PROPOSAL_SET_COL_DEF}
                        data={transferRowData(recalProposalSetState.recalProposalSetList)}
                        showPaginator={false}
                        headerActionButtons={memoBtns}
                        onDeleteButton={handleRowDeleteClick}
                        editable={false}
                        showAddIcon={allowCreate}
                        showDeleteButton={false}
                        showReloadIcon={false}
                        isScrollHighlighted={true}
                        selectionMode={false}
                        isRowHighligted={true}
                        rowSelection={"multiple"}
                        handleSelectionChanged={handleSelectionChange}
                        onRowDoubleClick={(e: any, entity: RecalProposalSetEntity) => handleRowDoubleClick(entity)}
                        gridHeight="customHeight"
                        customHeight="calc(100vh - 75px)"
                        ref={gridRef}
                        // isRowDrag={true}
                        // onRowDragged={handleRowDrag}
                        // onBodyScroll={(e: any) => changeCursor("recal-proposal-set-table", getShowMoveCursor())}
                        onAddClick={handleAdd}
                    />
                </div>
            </>
        );
    }, [allowCreate, handleSelectionChange, handleAdd, handleRowDeleteClick, handleRowDoubleClick, recalProposalSetState.recalProposalSetList, memoBtns])

    return <><TableWrapper>
        {memoRecalProposalSetTable}
        {recalProposalSetState.forceRefresh && <></>}
    </TableWrapper>
        {isLoading && <Loader Indicator="Spinner" size="Medium" />}
        <ConfirmDeleteModal headerText={`${WorkspaceConstant.Common.BUTTON_DELETE} ${RecalProposalSetConstant.Title.TITLE}`}
            contentText={`${MessageConstant.common.DELETE_ALERT_TITLE}\n${MessageConstant.common.DELETE_ALERT_MESSAGE}`}
            visible={isShowDelete}
            onCancelClick={handleCancel}
            onDeleteClick={handleDelete}
        />
    </>;
}

export default memo(RecalProposalSetTablePanel);
